import { createFileRoute } from '@tanstack/react-router';
import { ProductReleasesPage } from '@/pages/product-releases';
import { tabSearchSchema } from '@/routes/-shared/tabSearchSchema';

export const Route = createFileRoute('/referrer/_layout/releases')({
  component: ProductReleasesPage,
  validateSearch: tabSearchSchema,
});
